module.exports = __webpack_public_path__ + "static/plans-image-b144fad9cfe2ad9339136845a0c541b7.png";